import requestMagicLink from 'src/dataLayer/remoteData/babbelAPI/requestMagicLink'
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext'
import useAsyncData from 'src/viewLayer/components/hooks/useAsyncData'

export default function useMagicLinkRequest({ captchaResponseToken, email }) {
  const { locale } = useRouteParamsContext()
  const { inProgress, makeRequest } = useAsyncData(() =>
    requestMagicLink({ captchaResponseToken, email, locale }),
  )

  return {
    isMagicLinkRequestInProgress: inProgress,
    makeMagicLinkRequest: makeRequest,
  }
}
